<mat-card>
  <mat-card-title *ngIf="! InRoleInState(isInRole, isInState)">Observations Commission</mat-card-title>
  <mat-card-subtitle *ngIf="InRoleInState(isInRole, isInState)">Observations Commission</mat-card-subtitle>
  <mat-card-content>
    <form [formGroup]="obsFormGroup">
      <div style="padding-top: 20px;">
        <mat-form-field appearance="outline" fxFlex="80">
          <mat-label>Observations commission (max {{MAX_LENGTH}} cars.)</mat-label>
          <textarea formControlName="observations_commission" matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="5"
                    maxlength="{{MAX_LENGTH}}"
                    matTooltip="Vos observations sur cette demande"
                    placeholder="Vos observations..."
                    data-cy="txtarea-observations-commission">
          </textarea>
          <mat-hint align="end"><code>{{ObservationsText?.length}}</code> / <code>{{MAX_LENGTH}}</code></mat-hint>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
</mat-card>
